import React, { Component } from 'react';
// import { Link } from "react-router-dom";
import { connect } from 'react-redux';
import {InputText} from 'primereact/inputtext';
import {InputTextarea} from 'primereact/inputtextarea';

import {Button} from 'primereact/button';
import {Dropdown} from 'primereact/dropdown';
import {InputSwitch} from 'primereact/inputswitch';
import {Steps} from 'primereact/steps';
import {Toast} from "primereact/toast";
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Calendar} from 'primereact/calendar';
import {RadioButton} from 'primereact/radiobutton';
import {DateFormetter} from '../../../shared/utility';
import { DATATABLE_CONFIG, DROPDOWN_CONFIG } from '../../../shared/Config';
import Messages from '../../../shared/UI/Messages/Messages';
// import {PickList} from 'primereact/picklist';
import FooterButton from '../../../shared/UI/FooterButton/FooterButton';
import * as actions from '../../../store/actions/index';
import axios from '../../../axios-url';
import FileUpload from '../../../shared/UI/FileUpload/FileUpload';
import { DEFAULT_COMPANY_ID, UPLOAD_NAME_CONCAT, HASACCESS } from '../../../shared/utility';
import { COMPANY_SUBMENU_ID } from '../../../shared/Config';
import moment from 'moment';
import { MultiSelect } from 'primereact/multiselect';

class CompanyMaster extends Component {
    state = {
        activeIndex:0,
        stepsItems : [
            // {
            //     label: 'Selection',
            // },
            {
                label: 'Settings',
            }
            // ,  
            // {
            //     label: 'Approval Path',
            // }
        ],
        positions: [
            {label : 'Accountant',value : 'Accountant'},
            {label : 'Administrator',value : 'Administrator'}
        ],
        picklistSourceWeekDays: [
            {label : 'Saturday'},{label : 'Sunday'},{label : 'Monday'},{label : 'Tuesday'},{label : 'Wednesday'},{label : 'Thursday'},{label : 'Friday'}
        ],
        picklistTargetWeekDays: [],
        picklistSourceWeekEnds: [
            {label : 'Saturday'},{label : 'Sunday'},{label : 'Monday'},{label : 'Tuesday'},{label : 'Wednesday'},{label : 'Thursday'},{label : 'Friday'}
        ],
        picklistTargetWeekEnds: [],
        
        lateInToleranceAC: null, //for Absence Criteria
        earlyOutToleranceAC: null, //for Absence Criteria
        lateInToleranceLC: null, //for Late Criteria
        earlyOutToleranceLC: null, //for Late Criteria
        accLateInEarlyOutLimit: null, //Accumulated Early In late out limit in a month
        allowedLateInEarlyOut: '', //Accumulated Early In late out limit in a month
        emailFrequency: null, //email frequency settings
        timeMachineSyncFrequency: null, //attendance frequency settings
        xmlImpExpFrequency: null, //XML Imp/exp frequency settings
        timeEvaluationFrequency: null, //Time Evaluation frequency settings
        absentIfNoPunchIn: false, 
        absentIfNoPunchOut: false, 
        // employeeGroupPD: null, 
        cityPD: null, 
        perDiemAmount: null, 
        year: '', 
        yearsList: [],
        perDiemData: null, 
        toBeSentPerDiemData: [], 
        newPerDiemData: [], 
        currentSelectedItem: null,
        type: "edit",
        loginPageText: '',
        loadOnce: true,
        defaultUnpaidleaveType: null,
        companyName:'',
        loading:true,
        videolink: '',
        companyId:null,
        videoattachfilename: null,
        videoattachfileExt: null,
        videoattachfilepath: null,
        selectedModule:null,
        blnProcess:false,
        processData: [],
        approvalPathData:[],
        FromDate : new Date(),
        ToDate : new Date(),
        approvals : [],
        file:null,
        filesArray:[],
        ticketActionResponsibleDep : null,
        ticketActionResponsiblePerson : null,
        ticketActionid : null,
        visaActionResponsibleDep1 : null,
        visaActionResponsiblePerson1 : null,
        visaActionid : null,
        ramadanstartdate:null,//Ramadan Start Date
        ramadanenddate:null,//Ramadan End Date
        costcenterwithnolunchbreak:'', //ramadanLunchHourExceptionDep
        planType: null, //Restaurant setting
        zatcaEgsUnit: null,
        zatcaEgsUnitOptions: [],
        vatNo: '',
        ibanno: '',
    }

    planTypeOptions = [
        {label: 'Plan based on History Data', value: 'Plan based on History Data'},
        {label: 'Plan based on Forecast Data', value: 'Plan based on Forecast Data'},
    ];


    resetPDData = () => {
        this.setState({
            currentSelectedItem: null,
            cityPD: null,
            // employeeGroupPD: null, 
            perDiemAmount:'',
            year:'',
    });
    }

    generateYearsList = () => {
        let currentYear = new Date().getFullYear();
        let value = [];
        value.push({label:currentYear - 1, value:currentYear - 1}); 
        for (var i = currentYear - 1; i < (currentYear + 3); i++) {     
            value.push({ label: i + 1 ,value: i + 1});        
        }
        return value;
    }


    componentDidMount(){

        this.getAccess = HASACCESS(COMPANY_SUBMENU_ID);
        this.props.getKeywordValues();
        this.props.getMasterTableList('Company/GetCompany');
        this.props.getMasterKeywordList('Employee');

        setTimeout(()=> {
            this.props.getModuleLists();
        },1000)

        let yearsList = this.generateYearsList();
        this.setState({yearsList});

        setTimeout(()=> {
            this.props.getMasterKeywordList('OrgUnit');
            this.props.getMasterKeywordList('City');
            this.props.getMasterKeywordList('EmployeeGroup')
        }, 2000);

        setTimeout(()=> {
            this.props.getMasterKeywordList('City');
            axios.get('/master/api/DropDownValues/City')
                .then(response =>{
                    if(response.status === 200){
                        let data = []
                        if(response.data && response.data.length > 0){
                            data = response.data.map(list => {
                                let value= list.id;
                                let id = list.text;
                                let text = list.text;
                                return {label : text, value:value.toString(), id: id, cityName:text};
                            })
                        }
                        this.setState({functionalRoleOptions: data})
                    }}
                )
                .catch(err => {
                    this.growl.show({severity: 'error', summary: null, detail: 'Functional Roles Api Failed'});
                })   
        }, 2000);

        setTimeout(()=> {
            this.props.getMasterKeywordList('ActionType');
        }, 3000);

       
        
    }

    componentWillUpdate(){
         

        if(this.props.companyData && this.props.companyData.company!==undefined && this.state.loadOnce){
            let loginPageText = this.props.companyData.company.loginPageText;
            let defaultUnpaidleaveType = this.props.companyData.company.defaultUnpaidleaveType;
            let companyName = this.props.companyData.company.companyName;
            let videolink = this.props.companyData.company.videolink;
            let companyId = this.props.companyData.company.companyId;
            let videoattachfilename = this.props.companyData.company.videoattachfilename;
            let videoattachfileExt = this.props.companyData.company.videoattachfileExt;
            let videoattachfilepath = this.props.companyData.company.videoattachfilepath;

            let ticketActionResponsibleDep  = this.props.companyData.company.ticketActionResponsibleDep;
            let ticketActionResponsiblePerson  = this.props.companyData.company.ticketActionResponsiblePerson;
            let ticketActionid  = this.props.companyData.company.ticketActionid;

            let visaActionResponsibleDep1 = this.props.companyData.company.visaActionResponsibleDep1;
            let visaActionResponsiblePerson1  = this.props.companyData.company.visaActionResponsiblePerson1;
            let visaActionid = this.props.companyData.company.visaActionid;


            let lateInToleranceAC = this.props.companyData.company.absCreteriaLateInToleranceMin;
            let earlyOutToleranceAC = this.props.companyData.company.absCreteriaEarlyOutToleranceMin;
            let lateInToleranceLC = this.props.companyData.company.absCreteriaLateInToleranceMin;
            let earlyOutToleranceLC = this.props.companyData.company.absCreteriaEarlyOutToleranceMin;
            let absentIfNoPunchIn = this.props.companyData.company.absCreteriaAbsentIfNoPunchIn;
            let absentIfNoPunchOut = this.props.companyData.company.absCreteriaAbsentIfNoPunchOut;
            let accLateInEarlyOutLimit = this.props.companyData.company.monthlyLateInEarlyOutAllowedDurationMin; 
            let allowedLateInEarlyOut = this.props.companyData.company.monthlyLateInEarlyOutAllowedCount; 

            //Ramadan settings 
            let costcenterwithnolunchbreak =this.props.companyData.company.costcenterwithnolunchbreak
            let ramadanstartdate =this.props.companyData.company.ramadanstartdate
            let ramadanenddate =this.props.companyData.company.ramadanenddate
            

            let emailFrequency =  this.props.companyData.company.emailFrequency; 
            let timeMachineSyncFrequency =  this.props.companyData.company.timeMachineSyncFrequency1; 
            let xmlImpExpFrequency =  this.props.companyData.company.xmlexportImportFrequency1; 
            let timeEvaluationFrequency =  this.props.companyData.company.timeEvaluationFrequency; 

            let perDiemData = this.props.companyData.companyPerdiem || [];

            let filesArray = [];
            if(videoattachfilepath !==null){
                filesArray = [
                    {filePath:videoattachfilepath,fileName:videoattachfilename,fileExtention:videoattachfileExt}
                ]
            }

            this.setState({loadOnce:false,loginPageText:loginPageText,defaultUnpaidleaveType:defaultUnpaidleaveType,companyName:companyName,loading:false,videolink:videolink,companyId:companyId,videoattachfilename: videoattachfilename,videoattachfileExt: videoattachfileExt,videoattachfilepath: videoattachfilepath,filesArray:filesArray,ticketActionResponsibleDep:ticketActionResponsibleDep,ticketActionResponsiblePerson:ticketActionResponsiblePerson,ticketActionid:ticketActionid,visaActionResponsibleDep1:visaActionResponsibleDep1,visaActionResponsiblePerson1:visaActionResponsiblePerson1,visaActionid:visaActionid, lateInToleranceAC : lateInToleranceAC, earlyOutToleranceAC : earlyOutToleranceAC, lateInToleranceLC : lateInToleranceLC, earlyOutToleranceLC : earlyOutToleranceLC,accLateInEarlyOutLimit : accLateInEarlyOutLimit,allowedLateInEarlyOut : allowedLateInEarlyOut, ramadanstartdate : ramadanstartdate,ramadanenddate : ramadanenddate, costcenterwithnolunchbreak:costcenterwithnolunchbreak, emailFrequency :  emailFrequency, timeMachineSyncFrequency :  timeMachineSyncFrequency, xmlImpExpFrequency :  xmlImpExpFrequency, timeEvaluationFrequency: timeEvaluationFrequency, perDiemData:perDiemData,planType:this.props.companyData.company.planType,zatcaEgsUnit:this.props.companyData.company.zatcaEgsUnit,vatNo:this.props.companyData.company.vatNo || '',ibanno:this.props.companyData.company.ibanno || '',absentIfNoPunchIn:absentIfNoPunchIn,absentIfNoPunchOut:absentIfNoPunchOut})
        }
        // console.log(this.state.costcenterwithnolunchbreak,this.state.ramadanstartdate,this.state.ramadanenddate);
        // console.log(this.props.GetOrgUnit)
        
    }

    handleEditItem = (rowData,type) => {

        let rowDataCopy = {};
        for(let key in rowData){
            rowDataCopy[key] = rowData[key];
        }

        this.setState({
            currentSelectedItem: rowData, backupOfSelectedItem: rowDataCopy, 
            // employeeGroupPD: rowData.empGroupCode, 
            cityPD:rowData.city, perDiemAmount: rowData.perDiem, year: rowData.year
        })

        let toBeRemovedPDID = rowDataCopy.perdiemId;
        let toBeRemovedFrom = this.state.perDiemData;
        let filtered = toBeRemovedFrom.filter((PD) => PD.perdiemId !== toBeRemovedPDID)
        this.setState({perDiemData: filtered});
    }

    handleUpdateItem = () => {
        let toBeUpdatedValue = this.state.currentSelectedItem;
        // let updatedEmpGroup = this.state.employeeGroupPD;
        let updatedCity = this.state.cityPD;
        let updatedPDAmount = this.state.perDiemAmount;
        toBeUpdatedValue.perDiem = updatedPDAmount;
        toBeUpdatedValue.city = updatedCity;
        // toBeUpdatedValue.empGroupCode = updatedEmpGroup;
        let perDiemData = this.state.perDiemData;
        perDiemData.unshift(toBeUpdatedValue);
        this.setState({perDiemData:perDiemData});
        this.resetPDData();
    }

    handleCancelEditItem = () => {
        let filtered = this.state.perDiemData;
        filtered.unshift(this.state.backupOfSelectedItem);
        this.setState({perDiemData: filtered})
        this.resetPDData();
    }
  
  

    actionTemplate = (rowData, column) => {
        return <div className="actionCenter">
            {(this.getAccess!==undefined && this.getAccess.editAccess!== false) &&
                <Button onClick={() => this.handleEditItem(rowData,'edit')}  type="button" icon="pi pi-pencil" className="p-button-info" ></Button>
            }
            {(this.getAccess!==undefined && this.getAccess.deleteAccess!== false) &&
                <Button onClick={() => this.delete(rowData.holidayid)} icon="pi pi-trash"  className="p-button-danger"/>
            }
            </div>;
    }


    handleImageChange = (e) => {
        e.preventDefault();
        this.setState({loading:true});
        let file = e.target.files[0];
       
        let name= 'Company_'+UPLOAD_NAME_CONCAT+'_'+file.name;
        
        let readerShow = new FileReader();
        readerShow.readAsDataURL(file);
        readerShow.onloadend = () => {    
          this.setState({ file: readerShow.result});
        };
        const frmData = new FormData();
        
        frmData.append('file', file,  name );
        return axios.post('/master/api/upload?FolderName=Company', frmData ).then(response =>{
             
            let filesArray = [...this.state.filesArray];
            filesArray.push(response.data);
            this.setState({filesArray:filesArray,loading:false,videoattachfilename:response.data.fileName,videoattachfileExt:response.data.fileExtention,videoattachfilepath:response.data.filePath});            
        })
        .catch(err => {
            this.growl.show({severity: 'error', summary: null, detail: 'File Upload Failed'});
            this.setState({loading:false,videoattachfilename:null,videoattachfileExt:null,videoattachfilepath:null});
        })  
    }


    deleteImage = (path) => {
        let updatedValue = this.state.filesArray.filter((file,index) => {
            return file.filePath !== path
        });

        this.setState({filesArray:updatedValue,videoattachfilename: null,videoattachfileExt: null,videoattachfilepath: null});
   
    }

    

    manageNewAddition = () => {
        let NewPDVal = {
            PerdiemId: '00000000-0000-0000-0000-000000000000',
            Country:4,
            City: +this.state.cityPD.toString(),
            EmpGroupId:null,
            // empGroupCode: this.state.employeeGroupPD,
            EmpSubGroup:null,
            BegDate:null,
            EndDate:null,
            year:this.state.year,
            perDiem: this.state.perDiemAmount,
            CreatedBy:null,
            UpdatedDate :null,
            UpdatedBy:null,
            CompanyId:DEFAULT_COMPANY_ID,
        }
        let combinedPDArr =[ NewPDVal, ...this.state.perDiemData,]
        this.setState({perDiemData: combinedPDArr});
        this.resetPDData();
    }


    uploadData = () => {
        var data = {   
            CompanyId : DEFAULT_COMPANY_ID,        
            CompanyName: this.state.companyName,
            Modifiedby: 'Admin',
            Modifieddate:new Date(),
            Isactive : true,
            LoginPageText: this.state.loginPageText,
            DefaultUnpaidleaveType: this.state.defaultUnpaidleaveType,
            Videolink: this.state.videolink,
            Videoattachfilename: this.state.videoattachfilename,
            VideoattachfileExt: this.state.videoattachfileExt,
            Videoattachfilepath: this.state.videoattachfilepath,
            TicketActionResponsibleDep : this.state.ticketActionResponsibleDep,
            TicketActionResponsiblePerson : this.state.ticketActionResponsiblePerson,
            TicketActionid : this.state.ticketActionid,
            VisaActionResponsibleDep1 : this.state.visaActionResponsibleDep1,
            VisaActionResponsiblePerson1 : this.state.visaActionResponsiblePerson1,
            VisaActionid : this.state.visaActionid,
            AbsCreteriaLateInToleranceMin : this.state.lateInToleranceAC,
            AbsCreteriaEarlyOutToleranceMin : this.state.earlyOutToleranceAC,
            AbsCreteriaAbsentIfNoPunchIn : this.state.absentIfNoPunchIn,
            AbsCreteriaAbsentIfNoPunchOut : this.state.absentIfNoPunchOut,
            LateInCreteriaLateInToleranceMin : this.state.lateInToleranceLC,
            EarlyOutCreteriaEarlyOutToleranceMin : this.state.earlyOutToleranceLC,
            MonthlyLateInEarlyOutAllowedDurationMin : this.state.accLateInEarlyOutLimit,
            MonthlyLateInEarlyOutAllowedCount : this.state.allowedLateInEarlyOut,
            EmailFrequency : this.state.emailFrequency,
            TimeMachineSyncFrequency1 : this.state.timeMachineSyncFrequency,
            TimeEvaluationFrequency  : this.state.timeEvaluationFrequency,
            XmlexportImportFrequency1 : this.state.xmlImpExpFrequency,
            //Ramadan Settings 
            CostCenterWithnoLunchBreak:this.state.costcenterwithnolunchbreak,
            RamadanStartDate:this.state.ramadanstartdate,
            RamadanEndDate:this.state.ramadanenddate,
            //Restaurant Settings
            PlanType:this.state.planType,
            ZatcaEgsUnit:this.state.zatcaEgsUnit,
            VatNo:this.state.vatNo,
            Ibanno:this.state.ibanno,
        }

        let finalData = {
            company: data,
            companyPerdiem: this.state.perDiemData,
        }
        this.props.processDynamicData('Company',this.state.type,finalData,'Company/GetCompany')
        
    }

    
    addApproval = () => {
        var FromDate = DateFormetter(this.state.FromDate, this.props.userPref.dateFormat);
        var ToDate = DateFormetter(this.state.ToDate, this.props.userPref.dateFormat);
        let newDoc = {process : this.state.ApprovalPathProcess, path : this.state.ApprovalPathId, from:FromDate,to:ToDate};
        
        let docValue = [...this.state.approvals, newDoc];
        this.setState({approvals:docValue,blnProcess:false,ApprovalPathId:null,approvalPathData:[],processData:[],ApprovalPathProcess:null,selectedModule:null})
    }


    deleteApproval  = (removeIndex) => {
        const updatedDeptValue = this.state.approvals.filter((value,index) => {
            return removeIndex !== index;
        })
        this.setState({approvals:updatedDeptValue})
    }


    actionApproveTemplate = (rowData, column) => {
         let rowIndex = column.rowIndex;
        return <div className="actionCenter">
            <Button type="button" icon="pi pi-trash" className="p-button-danger" onClick={() => this.deleteApproval(rowIndex)}></Button>
            </div>;
    }

    prevMove = () => {

        let currentIndex = this.state.activeIndex;

        let prevValue = currentIndex - 1;

        this.setState({activeIndex:prevValue})

    }

    nextMove = () => {
        let currentIndex = this.state.activeIndex;

        let prevValue = currentIndex + 1;

        this.setState({activeIndex:prevValue})
    }

    changeData = (e) =>{
        let { name, value } = e.target;
        this.setState({[name]:value});
        if(name === 'selectedModule'){
            this.getProcess(value);
        }else if(name ==='ApprovalPathProcess'){
            this.getApprovalPath(value)
        }
    }

    getProcess = (value) => {          
        this.setState({loading : true});
        axios.get('/master/api/GetProcesses?Id='+value)
        .then(response =>{  
            if(response.status === 200){

                if(response.data.length > 0) {

                    let processData = response.data.map(process => {
                        return {label : process.processDescription,value : process.processId}
                    })

                    this.setState({blnProcess : true,processData:processData});
                } else {
                    this.setState({blnProcess : false});
                }
            }
            this.setState({loading : false});
        })
        .catch(err => {
            this.setState({loading : false});
        })    
    }

    getApprovalPath = (value) => {
        this.setState({loading : true});
        axios.get('/master/api/GetApprovalPath')
        .then(response =>{
            if(response.status === 200){
                let data = []
                if(response.data.length > 0) {
                    data = response.data.map(val => {
                        return { "label": val.approvalPathName,"value":val.approvalPathId,hrRequestType:val.hrRequestType }
                    });
                    let filterData = data.filter(vals => {
                        return vals.hrRequestType === value;
                    })

                    this.setState({approvalPathData:filterData});
                }
                
            }
            this.setState({loading : false});
        })
        .catch(err => {
            this.setState({loading : false});
        })    
        
    }


    resetData = () => {
        this.props.history.push('/dashboard');
    }
//ramadan settings

selectedcostcenter = () => {
  const { costcenterwithnolunchbreak } = this.state;
  return costcenterwithnolunchbreak
    ? costcenterwithnolunchbreak.split(',').map(v => v.toLowerCase())
    : [];
};

    handleChange(e) {
    const value = e.value; // this is an array like ['id1', 'id2']
    this.setState({ costcenterwithnolunchbreak: value.join(',') });

    
}
    render() {   
        let addAccess = true;
        let editAccess = true;
        if(this.getAccess!==undefined){
            if(this.getAccess.viewAccess === false){this.props.history.push('/dashboard')}
            addAccess = (this.getAccess.addAccess === true) ? true : false;
            editAccess = (this.getAccess.editAccess === true) ? true : false;
        }
        let accessButton = { addAccess : addAccess, editAccess : editAccess}

        let moduleLists = [];
        if(this.props.moduleLists && this.props.moduleLists.length > 0){
            moduleLists = this.props.moduleLists.map(module=> {
                return { label: module.label, value: module.moduleId}
            })
        }
     
        let leaveList = [];
        if(this.props.leaveList && this.props.leaveList.length > 0){
            leaveList = this.props.leaveList.map(list=> {
                return { label: list.label, value: list.uniqueId}
            })
        }

        let isEnabled = (this.state.loginPageText!=='') && (this.state.defaultUnpaidleaveType!==null)

        
        let isAppEnabled = (this.state.selectedModule!==null) && (this.state.ApprovalPathProcess!==null) && (this.state.ApprovalPathId!==null) && (this.state.FromDate!=='') && (this.state.ToDate!=='')
      
        let grid;
        const header = (
            <div style={{'textAlign':'right'}}>
                <InputText type="search" onInput={(e) => this.setState({globalFilter: e.target.value})} placeholder="Search..." />
            </div>
        );

        // let firstGrid = (                            
        //     <div className="p-grid mt1">
        //         <div className="p-col-6">
        //             <div className="p-col-12">
        //                 <label className="labeltop" htmlFor="input">President <span className="requiredColor">*</span></label>
        //             </div>
        //             <div className="p-col-12 ">
        //                     <MultiSelect className="p-col-12"  value={this.state.selectedPresident} options={this.state.positions}  onChange={e => this.handleChange(e)}  filter={true} name="selectedPresident" placeholder="Select President"/>
        //             </div>	
        //         </div>

        //         <div className="p-col-6 ">
        //             <div className="p-col-12">
        //                 <label className="labeltop" htmlFor="input">Vice President <span className="requiredColor">*</span></label>
        //             </div>
        //             <div className="p-col-12 ">
        //                     <MultiSelect className="p-col-12"  value={this.state.selectedVicePresident} options={this.state.positions}  onChange={e => this.handleChange(e)} filter={true} name="selectedVicePresident" placeholder="Select Vice President"/>
        //             </div>	
        //         </div>

        //         <div className="p-col-6 ">
        //             <div className="p-col-12">
        //                 <label className="labeltop" htmlFor="input">General Manager <span className="requiredColor">*</span></label>
        //             </div>
        //             <div className="p-col-12 ">
        //                     <MultiSelect className="p-col-12"  value={this.state.selectedGeneralManager} options={this.state.positions}  onChange={e => this.handleChange(e)} filter={true} name="selectedGeneralManager" placeholder="Select General Manager"/>
        //             </div>	
        //         </div>

                

        //         <div className="p-col-6 ">
        //             <div className="p-col-12">
        //                 <label className="labeltop" htmlFor="input">Department Manager <span className="requiredColor">*</span></label>
        //             </div>
        //             <div className="p-col-12 ">
        //                     <MultiSelect className="p-col-12"  value={this.state.selectedDepartmentManager} options={this.state.positions}  onChange={e => this.handleChange(e)} filter={true} name="selectedDepartmentManager" placeholder="Select Department Manager"/>
        //             </div>	
        //         </div>

        //         <div className="p-col-6 ">
        //             <div className="p-col-12">
        //                 <label className="labeltop" htmlFor="input">Section Head <span className="requiredColor">*</span></label>
        //             </div>
        //             <div className="p-col-12 ">
        //                     <MultiSelect className="p-col-12"  value={this.state.selectedSectionHead} options={this.state.positions}  onChange={e => this.handleChange(e)} filter={true} name="selectedSectionHead" placeholder="Select Section Head"/>
        //             </div>	
        //         </div>


        //         <div className="p-col-6 ">
        //             <div className="p-col-12">
        //                 <label className="labeltop" htmlFor="input">Safety Position <span className="requiredColor">*</span></label>
        //             </div>
        //             <div className="p-col-12 ">
        //                     <MultiSelect className="p-col-12"  value={this.state.selectedSafetyPosition} options={this.state.positions}  onChange={e => this.handleChange(e)} filter={true} name="selectedSafetyPosition" placeholder="Select Safety Position"/>
        //             </div>	
        //         </div>
        //     </div>	
        // );

        let secondGrid = (                            
            <div className="p-grid mt1">
                <div className="p-col-12 p-lg-12">
                    <div className="card card-w-title">
                        <h1>General Settings</h1>
                        <div className="p-grid">
                            {/* <div className="p-col-6">
                                <div className="p-col-12">
                                    <label className="labeltop" htmlFor="input">Remainder Alert Frequency</label>
                                </div>
                                <div className="p-col-12 ">
                                        <Calendar placeholder="Remainder Alert Frequency" name="alertFrequency" 
                                        value={this.state.alertFrequency} onChange={this.changeData}  timeOnly={true} showTime={true} showSeconds={true} className="width100"  />
                                </div>	
                            </div>

                            <div className="p-col-6">
                                <div className="p-col-12">
                                    <label className="labeltop" htmlFor="input">Normal Intimation Alert</label>
                                </div>
                                <div className="p-col-12 ">
                                        <Calendar placeholder="Normal Intimation Alert" name="intimationAlert" 
                                        value={this.state.intimationAlert}  onChange={this.changeData} timeOnly={true} showTime={true} showSeconds={true} className="width100"  />
                                </div>	
                            </div>

                            <div className="p-col-6">
                                <div className="p-col-12">
                                    <label className="labeltop" htmlFor="input">Frequency Of Remainder</label>
                                </div>
                                <div className="p-col-12">
                                        <InputText className="p-lg-12" placeholder="Frequency Of Remainder" name="frequencyOfRemainder" 
                                        value={this.state.frequencyOfRemainder}  onChange={this.changeData}/>
                                </div>	
                            </div>

                            <div className="p-col-3">
                                <div className="p-col-12">
                                    <label className="labeltop" htmlFor="textarea">Auto Approvals</label>
                                </div>
                                <div className="p-col-12 ">
                                        <InputSwitch checked={this.state.autoApprovals} name="autoApprovals"  onChange={this.changeData} />
                                </div> 
                            </div>
                            <div className="p-col-3">
                                <div className="p-col-12">
                                    <label className="labeltop" htmlFor="textarea">Auto Refresh</label>
                                </div>
                                <div className="p-col-12 ">
                                        <InputSwitch checked={this.state.autoRefresh} name="autoRefresh"  onChange={this.changeData} />
                                </div> 
                            </div>                         

                             <div className="p-col-6">    
                            <div className="p-col-12">
                                    <label className="labeltop" htmlFor="textarea">Select WeekDays</label>
                                </div>                            
                                <div className="p-col-12 ">
                                     <PickList source={this.state.picklistSourceWeekDays} target={this.state.picklistTargetWeekDays} sourceHeader="WeekDays" targetHeader="Selected"
                                        responsive={true} itemTemplate={(val) => <span>{val.label}</span>} 
                                        onChange={event => this.setState({picklistSourceWeekDays: event.source, picklistTargetWeekDays: event.target})} />  
                                </div>	
                            </div

                            <div className="p-col-6">    
                            <div className="p-col-12">
                                    <label className="labeltop" htmlFor="textarea">Select WeekEnds</label>
                                </div>                            
                                <div className="p-col-12 ">
                                     <PickList source={this.state.picklistSourceWeekEnds} target={this.state.picklistTargetWeekEnds} sourceHeader="WeekEnds" targetHeader="Selected"
                                        responsive={true} itemTemplate={(val) => <span>{val.label}</span>} 
                                        onChange={event => this.setState({picklistSourceWeekEnds: event.source, picklistTargetWeekEnds: event.target})} />  
                                </div>	
                            </div> */}
                         
                            <div className="p-col-6">
                                <div className="p-col-12">
                                    <label className="labeltop" htmlFor="input">Default Unpaid Leave</label>
                                </div>
                                <div className="p-col-12 ">
                                        <Dropdown className="p-col-12"  value={this.state.defaultUnpaidleaveType} options={leaveList} onChange={this.changeData}   name="defaultUnpaidleaveType" placeholder="Select Leave Type" {...DROPDOWN_CONFIG}/>
                                </div>	
                            </div>

                       
                        </div>


                        <h1>Action Settings</h1>
                        <div className="p-grid">
                            <div className="p-col-4">
                                <div className="p-col-12">
                                    <label className="labeltop" htmlFor="input">Ticket Responsible Department</label>
                                </div>
                                <div className="p-col-12 ">
                                    <Dropdown placeholder="Select Department" name="ticketActionResponsibleDep" value={this.state.ticketActionResponsibleDep} options={this.props.GetOrgUnit} onChange={this.changeData} className="p-col-12"  {...DROPDOWN_CONFIG}/>
                                </div>	
                            </div>

                            <div className="p-col-4">
                                <div className="p-col-12">
                                    <label className="labeltop" htmlFor="input">Ticket Responsible Person</label>
                                </div>
                                <div className="p-col-12 ">
                                    <Dropdown placeholder="Select Employee" name="ticketActionResponsiblePerson" value={this.state.ticketActionResponsiblePerson} options={this.props.Employee} onChange={this.changeData} className="p-col-12"  {...DROPDOWN_CONFIG}/>
                                </div>	
                            </div>

                            <div className="p-col-4">
                                <div className="p-col-12">
                                    <label className="labeltop" htmlFor="input">Ticket Action</label>
                                </div>
                                <div className="p-col-12 ">
                                    <Dropdown placeholder="Select Action" name="ticketActionid" value={this.state.ticketActionid} options={this.props.ActionType} onChange={this.changeData} className="p-col-12"  {...DROPDOWN_CONFIG}/>
                                </div>	
                            </div>


                            <div className="p-col-4">
                                <div className="p-col-12">
                                    <label className="labeltop" htmlFor="input">Visa Action Responsible Department</label>
                                </div>
                                <div className="p-col-12 ">
                                    <Dropdown placeholder="Select Department" name="visaActionResponsibleDep1" value={this.state.visaActionResponsibleDep1} options={this.props.GetOrgUnit} onChange={this.changeData} className="p-col-12"  {...DROPDOWN_CONFIG}/>
                                </div>	
                            </div>

                            <div className="p-col-4">
                                <div className="p-col-12">
                                    <label className="labeltop" htmlFor="input">Visa Action Responsible Person</label>
                                </div>
                                <div className="p-col-12 ">
                                    <Dropdown placeholder="Select Employee" name="visaActionResponsiblePerson1" value={this.state.visaActionResponsiblePerson1} options={this.props.Employee} onChange={this.changeData} className="p-col-12"  {...DROPDOWN_CONFIG}/>
                                </div>	
                            </div>

                            <div className="p-col-4">
                                <div className="p-col-12">
                                    <label className="labeltop" htmlFor="input">Visa Action</label>
                                </div>
                                <div className="p-col-12 ">
                                    <Dropdown placeholder="Select Action" name="visaActionid" value={this.state.visaActionid} options={this.props.ActionType} onChange={this.changeData} className="p-col-12"  {...DROPDOWN_CONFIG}/>
                                </div>	
                            </div>

                        </div>
                        {/* <h1>Team Leader Settings</h1>
                        <div className="p-grid">
                            <div className="p-col-6">
                                <div className="p-col-12">
                                    <label className="labeltop" htmlFor="input">Team Leader</label>
                                </div>
                                <div className="p-col-12 ">
                                        <MultiSelect className="p-col-12"  value={this.state.selectedTeamLeader} options={this.state.positions}  onChange={e => this.handleChange(e)}  filter={true} name="selectedTeamLeader" placeholder="Select Team Leader"/>
                                </div>	
                            </div>

                            <div className="p-col-6 ">
                                <div className="p-col-12">
                                    <label className="labeltop" htmlFor="input">Team Member</label>
                                </div>
                                <div className="p-col-12 ">
                                        <MultiSelect className="p-col-12"  value={this.state.selectedTeamMember} options={this.state.positions}  onChange={e => this.handleChange(e)} filter={true} name="selectedTeamMember" placeholder="Select Team Member"/>
                                </div>	
                            </div>
                        </div> */}

                        
                        {/* <h1>RC Comitte Settings</h1>
                        <div className="p-grid">
                            <div className="p-col-6">
                                <div className="p-col-12">
                                    <label className="labeltop" htmlFor="input">RC Comitte 1</label>
                                </div>
                                <div className="p-col-12 ">
                                        <Dropdown className="p-col-12"  value={this.state.selectedRccomitte1} options={relavantOption}  onChange={e => this.handleChange(e)}  filter={true} name="selectedRccomitte1" placeholder="RC Comitte 1" autoWidth={false} />
                                </div>	
                            </div>

                            <div className="p-col-6">
                                <div className="p-col-12">
                                    <label className="labeltop" htmlFor="input">RC Comitte 2</label>
                                </div>
                                <div className="p-col-12 ">
                                        <Dropdown className="p-col-12"  value={this.state.selectedRccomitte2} options={relavantOption}  onChange={e => this.handleChange(e)}  filter={true} name="selectedRccomitte2" placeholder="RC Comitte 2" autoWidth={false} />
                                </div>	
                            </div>

                            <div className="p-col-6">
                                <div className="p-col-12">
                                    <label className="labeltop" htmlFor="input">RC Comitte 3</label>
                                </div>
                                <div className="p-col-12 ">
                                        <Dropdown className="p-col-12"  value={this.state.selectedRccomitte3} options={relavantOption}  onChange={e => this.handleChange(e)}  filter={true} name="selectedRccomitte3" placeholder="RC Comitte 3" autoWidth={false} />
                                </div>	
                            </div>

                            <div className="p-col-6">
                                <div className="p-col-12">
                                    <label className="labeltop" htmlFor="input">RC Comitte 4</label>
                                </div>
                                <div className="p-col-12 ">
                                        <Dropdown className="p-col-12"  value={this.state.selectedRccomitte4} options={relavantOption}  onChange={e => this.handleChange(e)}  filter={true} name="selectedRccomitte4" placeholder="RC Comitte 4" autoWidth={false} />
                                </div>	
                            </div>


                            <div className="p-col-6">
                                <div className="p-col-12">
                                    <label className="labeltop" htmlFor="input">RC Comitte 5</label>
                                </div>
                                <div className="p-col-12 ">
                                        <Dropdown className="p-col-12"  value={this.state.selectedRccomitte5} options={relavantOption}  onChange={e => this.handleChange(e)}  filter={true} name="selectedRccomitte5" placeholder="RC Comitte 5" autoWidth={false} />
                                </div>	
                            </div>


                            <div className="p-col-6">
                                <div className="p-col-12">
                                    <label className="labeltop" htmlFor="input">RC Comitte 6</label>
                                </div>
                                <div className="p-col-12 ">
                                        <Dropdown className="p-col-12"  value={this.state.selectedRccomitte6} options={relavantOption}  onChange={e => this.handleChange(e)}  filter={true} name="selectedRccomitte6" placeholder="RC Comitte 6" autoWidth={false} />
                                </div>	
                            </div>


                            <div className="p-col-6">
                                <div className="p-col-12">
                                    <label className="labeltop" htmlFor="input">RC Comitte 7</label>
                                </div>
                                <div className="p-col-12 ">
                                        <Dropdown className="p-col-12"  value={this.state.selectedRccomitte7} options={relavantOption}  onChange={e => this.handleChange(e)}  filter={true} name="selectedRccomitte7" placeholder="RC Comitte 7" autoWidth={false} />
                                </div>	
                            </div>

                            <div className="p-col-6">
                                <div className="p-col-12">
                                    <label className="labeltop" htmlFor="input">RC Comitte 8</label>
                                </div>
                                <div className="p-col-12 ">
                                        <Dropdown className="p-col-12"  value={this.state.selectedRccomitte8} options={relavantOption}  onChange={e => this.handleChange(e)}  filter={true} name="selectedRccomitte8" placeholder="RC Comitte 8" autoWidth={false} />
                                </div>	
                            </div>


                            <div className="p-col-6">
                                <div className="p-col-12">
                                    <label className="labeltop" htmlFor="input">RC Comitte 9</label>
                                </div>
                                <div className="p-col-12 ">
                                        <Dropdown className="p-col-12"  value={this.state.selectedRccomitte9} options={relavantOption}  onChange={e => this.handleChange(e)}  filter={true} name="selectedRccomitte9" placeholder="RC Comitte 9" autoWidth={false} />
                                </div>	
                            </div>


                            <div className="p-col-6">
                                <div className="p-col-12">
                                    <label className="labeltop" htmlFor="input">RC Comitte 10</label>
                                </div>
                                <div className="p-col-12 ">
                                        <Dropdown className="p-col-12"  value={this.state.selectedRccomitte10} options={relavantOption}  onChange={e => this.handleChange(e)}  filter={true} name="selectedRccomitte10" placeholder="RC Comitte 10" autoWidth={false} />
                                </div>	
                            </div>
                        </div> */}

                        
                        <h1>Welcome Page Settings</h1>
                        <div className="p-grid">

                        <div className="p-col-12">
                                <div className="p-col-12">
                                    <label className="labeltop" htmlFor="input">Company Name<span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                    <InputText className="width100" placeholder="Company Name" name="companyName" value={this.state.companyName}  onChange={this.changeData}/>
                                </div>	
                            </div>

                            <div className="p-col-12">
                                <div className="p-col-12">
                                    <label className="labeltop" htmlFor="input">Welcome Page Content<span className="requiredColor">*</span></label>
                                </div>
                                <div className="p-col-12 ">
                                        <InputTextarea rows={5} className="width100" placeholder="Welcome Page Content" name="loginPageText" value={this.state.loginPageText}    onChange={this.changeData} autoResize={true} />
                                </div>	
                            </div>

                            <div className="p-col-12">
                                <div className="p-col-12">
                                    <label className="labeltop" htmlFor="input">Dashboard Video</label>
                                </div>
                                <div className="p-col-12 ">
                                <InputText className="width100" placeholder="Paste Video URL" name="videolink" 
                                        value={this.state.videolink}      onChange={this.changeData}/>
                                    <br/><br/>
                                    (OR)
                                    <br/><br/>
                                    
                                <FileUpload handleImageChange={this.handleImageChange} count={1} filesArray={this.state.filesArray} deleteImage={this.deleteImage}/>

                                </div>	
                            </div>
                        </div>

                        <h1>Time Management Settings</h1>
                        <h2>Absence Criteria</h2>
                        <div className="p-grid">
                            
                            <div className="p-col-6">
                                <div className="p-col-12">
                                    <label className="labeltop" htmlFor="input">Late In Tolerance(Minutes)</label>
                                </div>
                                <div className="p-col-12 ">
                                    <InputText placeholder="Late In Tolerance(Minutes)" name="lateInToleranceAC" 
                                    value={this.state.lateInToleranceAC}  onChange={this.changeData} className="width100"
                                    keyfilter="int"
                                    />
                                </div>	
                            </div>

                            <div className="p-col-6">
                                <div className="p-col-12">
                                    <label className="labeltop" htmlFor="input">Early Out Tolerance(Minutes)</label>
                                </div>
                                <div className="p-col-12 ">
                                    <InputText placeholder="Early Out Tolerance(Minutes)" name="earlyOutToleranceAC" 
                                    value={this.state.earlyOutToleranceAC}  onChange={this.changeData} className="width100"
                                    keyfilter="int"
                                    />
                                </div>	
                            </div>

                            <div className="p-col-6">
                                <div className="p-col-12">
                                    <label className="labeltop" htmlFor="input">No Punch-In</label>
                                </div>	
                                <div className="p-col-6">
                                    <RadioButton value="true" name="absentIfNoPunchIn" checked={this.state.absentIfNoPunchIn == true}  onChange={() => this.setState({absentIfNoPunchIn: true})} />
                                    <label htmlFor="rb1" className="p-radiobutton-label">Absent</label>
                                </div>
                                <div className="p-col-6">
                                    <RadioButton value="false" name="absentIfNoPunchIn" checked={this.state.absentIfNoPunchIn != true}  onChange={() => this.setState({absentIfNoPunchIn: false})}/>
                                    <label htmlFor="rb1" className="p-radiobutton-label">Present</label>
                                </div>
                            </div>

                            <div className="p-col-6">
                                <div className="p-col-12">
                                    <label className="labeltop" htmlFor="input">No Punch-Out</label>
                                </div>	
                                <div className="p-col-6">
                                    <RadioButton value="true" name="absentIfNoPunchOut" checked={this.state.absentIfNoPunchOut == true} onChange={() => this.setState({absentIfNoPunchOut: true})}  />
                                    <label htmlFor="rb1" className="p-radiobutton-label">Absent</label>
                                </div>
                                <div className="p-col-6">
                                    <RadioButton value="false" name="absentIfNoPunchOut" checked={this.state.absentIfNoPunchOut == false}
                                    onChange={() => this.setState({absentIfNoPunchOut: false})} />
                                    <label htmlFor="rb1" className="p-radiobutton-label">Present</label>
                                </div>
                            </div>



                        </div>

                        <h2>Late-In &amp; Early-Out Criteria</h2>
                        <div className="p-grid">
                            
                            <div className="p-col-6">
                                <div className="p-col-12">
                                    <label className="labeltop" htmlFor="input">Late In Tolerance(Minutes)</label>
                                </div>
                                <div className="p-col-12 ">
                                    <InputText placeholder="Late In Tolerance(Minutes)" name="lateInToleranceLC" 
                                    value={this.state.lateInToleranceLC}  onChange={this.changeData} className="width100"
                                    keyfilter="int"
                                    />
                                </div>	
                            </div>

                            <div className="p-col-6">
                                <div className="p-col-12">
                                    <label className="labeltop" htmlFor="input">Early Out Tolerance(Minutes)</label>
                                </div>
                                <div className="p-col-12 ">
                                    <InputText placeholder="Early Out Tolerance(Minutes)" name="earlyOutToleranceLC" 
                                    value={this.state.earlyOutToleranceLC}  onChange={this.changeData} className="width100"
                                    keyfilter="int"
                                    />
                                </div>	
                            </div>

                            <div className="p-col-6">
                                <div className="p-col-12">
                                    <label className="labeltop" htmlFor="input">Allowed total accumulated late-in and early-out duration in a month(Minutes)</label>
                                </div>
                                <div className="p-col-12 ">
                                    <InputText placeholder="Accumulated late-in and early-out duration in a month(Minutes)" name="accLateInEarlyOutLimit" 
                                    value={this.state.accLateInEarlyOutLimit}  onChange={this.changeData} className="width100"
                                    keyfilter="int"
                                    />
                                </div>	
                            </div>

                            <div className="p-col-6">
                                <div className="p-col-12">
                                    <label className="labeltop" htmlFor="input">Allowed total number of Late-in and Early-out in a month (Minutes)</label>
                                </div>
                                <div className="p-col-12">
                                    <InputText placeholder="Allowed number of Late-in and Early-out (Minutes)" name="allowedLateInEarlyOut" 
                                    value={this.state.allowedLateInEarlyOut}  onChange={this.changeData} className="width100"
                                    keyfilter="int"
                                    />
                                </div>	
                            </div>

                        </div>

{/* Ramadan Settings */}
                        <h2>Ramadan Settings</h2>
                        <div className="p-grid">
            
                            <div className="p-col-12 p-md-6 p-lg-6">
                                <label className="label">Start Date </label>
                              <Calendar className="p-col-12" name="ramadanstartdate" placeholder="Start Date " value={this.state.ramadanstartdate}  onChange={this.changeData}/>
                              </div>                                
                            
                            <div className="p-col-12 p-md-6 p-lg-6">
                                <label className="label">End Date </label>
                                <Calendar className="p-col-12" name="ramadanenddate" placeholder="End Date " value={this.state.ramadanenddate}  onChange={this.changeData}/>                          
                            </div>


                            <div className="p-col-12 p-md-6 p-lg-4">
                                {/* <label>Select Organization Unit<span className="requiredColor">*</span></label> */}
                                {/* <label>Lunch Hour Detection Exception Organization Unit</label> */}
                                <div className="p-col-12">
                                    <label className="labeltop" htmlFor="input">Lunch Hour Detection Exception Organization Unit</label>
                                </div>
                                {/* <div className="mt1 ">
                                <Dropdown placeholder="Select Organization Unit"  name="OrgUnitId"  value={this.state.OrgUnitId} options={releventOption} onChange={this.updateDetail} className="width100" {...DROPDOWN_CONFIG} />
                                </div>                                 */}
                                <div className="p-col-12 ">
                                    {/* <Dropdown placeholder="Select Department" name="costcenterwithnolunchbreak" value={this.state.costcenterwithnolunchbreak} options={this.props.GetOrgUnit} onChange={this.changeData} className="p-col-12"  {...DROPDOWN_CONFIG}/> */}
                                    {/* <MultiSelect value={this.state.costcenterwithnolunchbreak} options={this.props.GetOrgUnit} filter={true} name="costcenterwithnolunchbreak" placeholder="Select Department"/> */}
                                    <MultiSelect className="p-col-12 " value={this.selectedcostcenter()} options={this.props.GetOrgUnit}  onChange={e => this.handleChange(e)} filter={true} name="costcenterwithnolunchbreak" placeholder="Select Department" {...DROPDOWN_CONFIG}/>
                                    </div>
                            </div>
                        </div>
{/* End of Ramadan Time Settings */}
                        <h1>Service Frequency Settings</h1>
                        <div className="p-grid">

                            <div className="p-col-4">
                                <div className="p-col-12">
                                    <label className="labeltop" htmlFor="input">Email Frequency(Seconds)</label>
                                </div>
                                <div className="p-col-12 ">
                                    <InputText placeholder="E-mail Frequency (Seconds)" name="emailFrequency" 
                                    value={this.state.emailFrequency}  onChange={this.changeData} className="width100"
                                    keyfilter="int"
                                    />
                                </div>	
                            </div>

                            <div className="p-col-4">
                                <div className="p-col-12">
                                    <label className="labeltop" htmlFor="input">Time Machine Synchronisation Frequency(Seconds)</label>
                                </div>
                                <div className="p-col-12 ">
                                    <InputText 
                                    placeholder="Time Machine Synchronisation Frequency (Seconds)" 
                                    name="timeMachineSyncFrequency" 
                                    value={this.state.timeMachineSyncFrequency}  
                                    onChange={this.changeData} 
                                    className="width100"
                                    keyfilter="int"
                                    />
                                </div>	
                            </div>

                            <div className="p-col-4">
                                <div className="p-col-12">
                                    <label className="labeltop" htmlFor="input">XML Import/Export Frequency(Seconds)</label>
                                </div>
                                <div className="p-col-12 ">
                                    <InputText 
                                    placeholder="XML Import/Export Frequency (Seconds)" 
                                    name="xmlImpExpFrequency" 
                                    value={this.state.xmlImpExpFrequency}  
                                    onChange={this.changeData} 
                                    className="width100"
                                    keyfilter="int"
                                    />
                                </div>	
                            </div>

                            <div className="p-col-4">
                                <div className="p-col-12">
                                    <label className="labeltop" htmlFor="input">Time Evaluation Frequency(Seconds)</label>
                                </div>
                                <div className="p-col-12 ">
                                    <InputText 
                                    placeholder="Time Evaluation Frequency (Seconds)" 
                                    name="timeEvaluationFrequency" 
                                    value={this.state.timeEvaluationFrequency}  
                                    onChange={this.changeData} 
                                    className="width100"
                                    keyfilter="int"
                                    />
                                </div>	
                            </div>

                        </div>

                        <h1>Restaurant Setting</h1>
                        <div className="p-grid">
                            <div className="p-col-3">
                                <div className="p-col-12">
                                    <label className="labeltop" htmlFor="input">Plan Type</label>
                                </div>
                                <div className="p-col-12 ">
                                    <Dropdown placeholder="Select Plan Type" name="planType" value={this.state.planType} options={this.planTypeOptions} onChange={this.changeData} className="p-col-12" {...DROPDOWN_CONFIG}/>
                                </div>
                            </div>

                            <div className="p-col-3">
                                <div className="p-col-12">
                                    <label className="labeltop" htmlFor="input">ZATCA EGS Unit</label>
                                </div>
                                <div className="p-col-12 ">
                                    <Dropdown placeholder="Select ZATCA EGS Unit" name="zatcaEgsUnit" value={this.state.zatcaEgsUnit} options={this.state.zatcaEgsUnitOptions} onChange={this.changeData} className="p-col-12" {...DROPDOWN_CONFIG}/>
                                </div>
                            </div>

                            <div className="p-col-3">
                                <div className="p-col-12">
                                    <label className="labeltop" htmlFor="input">VAT No</label>
                                </div>
                                <div className="p-col-12 ">
                                    <InputText placeholder="VAT No" name="vatNo" value={this.state.vatNo} onChange={this.changeData} className="width100" />
                                </div>
                            </div>

                            <div className="p-col-3">
                                <div className="p-col-12">
                                    <label className="labeltop" htmlFor="input">IBAN No</label>
                                </div>
                                <div className="p-col-12 ">
                                    <InputText placeholder="IBAN No" name="ibanno" value={this.state.ibanno} onChange={this.changeData} className="width100" />
                                </div>
                            </div>
                        </div>

                        <h1>PerDiem Settings</h1>
                        <div className="p-grid">
                            <div className="p-col-12" style={{marginTop:'2em'}}>                     
                                <DataTable  value={this.state.perDiemData} globalFilter={this.state.globalFilter} header={header} {...DATATABLE_CONFIG} >
                                    {/* <Column field="empGroupCode" header="Employee Group Code" /> */}
                                    <Column field="cityName" header="City" />
                                    <Column field="perDiem" header="Per Diem Amount" />
                                    <Column field="year" header="Year" />
                                    <Column body={this.actionTemplate} header="Action" />
                                </DataTable>                      
                            </div>

                            {/* <div className="p-col-3">
                                <div className="p-col-12">
                                    <label className="labeltop" htmlFor="input">Employee Group</label>
                                </div>
                                <div className="p-col-12 ">
                                    <Dropdown placeholder="Select Employee Group" name="employeeGroupPD" value={this.state.employeeGroupPD} options={this.props.GetOrgUnit} onChange={this.changeData} className="p-col-12"  {...DROPDOWN_CONFIG}/>
                                </div>	
                            </div> */}

                            <div className="p-col-3">
                                <div className="p-col-12">
                                    <label className="labeltop" htmlFor="input">City</label>
                                </div>
                                <div className="p-col-12 ">
                                    <Dropdown placeholder="Select City" name="cityPD" value={this.state.cityPD} options={this.state.functionalRoleOptions} onChange={this.changeData} className="p-col-12"  {...DROPDOWN_CONFIG}/>
                                </div>	
                            </div>

                            <div className="p-col-3">
                                <div className="p-col-12">
                                    <label className="labeltop" htmlFor="input">PerDiem Amount (Default Currency)</label>
                                </div>
                                <div className="p-col-12 ">
                                    <InputText 
                                    placeholder="PerDiem Amount (Default Currency)" 
                                    name="perDiemAmount" 
                                    value={this.state.perDiemAmount}  
                                    onChange={this.changeData} 
                                    className="width100"
                                    keyfilter="int"
                                    />
                                </div>	
                            </div>

                            <div className="p-col-3">
                                <div className="p-col-12">
                                    <label className="labeltop" htmlFor="input">Year</label>
                                </div>
                                <div className="p-col-12 ">
                                    <Dropdown placeholder="Select Year" name="year" value={this.state.year} options={this.state.yearsList} onChange={this.changeData} className="p-col-12"  {...DROPDOWN_CONFIG}/>
                                </div>	
                            </div>

                            {(this.state.currentSelectedItem == null) ? 
                                <div className="p-col-3">
                                    <div className="p-col-12">                                   
                                    </div>
                                    <div className="p-col-12">
                                    <Button type="button" label="Add" icon="pi pi-plus" className="p-button-success p-button-rounded" onClick={() => this.manageNewAddition()} />
                                    </div>
                                </div>
                                :
                                <div className="p-col-3">
                                    <div className="p-col-12">                                   
                                    </div>
                                    <div className="p-col-12">
                                    <Button type="button" label="Update" icon="pi pi-plus" className="p-button-warning p-button-rounded" onClick= {() => this.handleUpdateItem()} />
                                    </div>
                                    <div className="p-col-12">
                                    <Button type="button" label="Cancel" className="p-button-success p-button-rounded" onClick={() => this.handleCancelEditItem()} />
                                    </div>
                                </div> 
                                
                            }



                        </div>

                    </div>
                </div>
            </div>
        );
    

        let thirdGrid = (
           
            <div className="mt3">
                 <div className="p-grid">
                    <div className="p-col-12 p-md-6 p-lg-3">
                        <label className="label">Module</label>
                        <div className="mt1"><Dropdown className="p-col-12" options={moduleLists} name="selectedModule" value={this.state.selectedModule} onChange={this.changeData} placeholder="Select Module" {...DROPDOWN_CONFIG}/></div>   
                    </div>

                    { this.state.blnProcess === true &&
                    <div className="p-col-12 p-md-6 p-lg-3">
                        <label className="label">Process</label>
                        <div className="mt1"><Dropdown className="p-col-12" options={this.state.processData} name="ApprovalPathProcess" value={this.state.ApprovalPathProcess} onChange={this.changeData} placeholder="Select Process" {...DROPDOWN_CONFIG}/></div>   
                    </div>
                    } 

                    <div className="p-col-12 p-md-6 p-lg-3">
                        <label className="label">Approval Path Id</label>
                        <div className="mt1"><Dropdown className="p-col-12" options={this.state.approvalPathData} name="ApprovalPathId" value={this.state.ApprovalPathId} onChange={this.changeData}  placeholder="Select Approval Path" {...DROPDOWN_CONFIG}/></div>                             
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-3">
                        <label  className="label">From</label>
                        <div className="mt1"><Calendar className="width100" placeholder="From Date" name="FromDate"  value={this.state.FromDate} onChange={(e) => this.setState({FromDate: e.value})}/></div>                               
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-3">
                        <label className="label">To</label>
                        <div className="mt1"><Calendar className="width100"  placeholder="To Date" name="ToDate" value={this.state.ToDate} onChange={(e) => this.setState({ToDate: e.value})}/></div>                               
                    </div>
                </div> 


                <div className="p-col-12 p-md-12" style={{textAlign:'right',paddingRight:'0px'}}>
                    <Button disabled={!isAppEnabled} label="Add" style={{marginBottom:'10px'}} className="p-button-primary" icon="pi pi-plus" onClick={this.addApproval}/>
                </div>
        
                <DataTable className="animated fadeIn" rowHover responsive value={this.state.approvals}>
                    <Column field="process" header="Process" />
                    <Column field="path" header="Approva Path" />
                    <Column field="from" header="From Date"/>
                    <Column field="to" header="To Date" />
                    <Column body={this.actionApproveTemplate}/>
                </DataTable> 

            </div>
        )

        if(this.state.activeIndex === 0){
            // grid = firstGrid;
            grid = secondGrid;
        }else if(this.state.activeIndex === 1){
            grid = thirdGrid;
        }else if(this.state.activeIndex === 2){
            // grid = thirdGrid;
        }


        return (
            <div className="p-grid companyMaster">
                { this.state.loading && <div className="page-loader"></div>}
                { this.props.loading && <div className="page-loader"></div>}
                { this.props.error !== null && <Messages type="error" message={this.props.error}/>}
                { this.props.success !== null && <Messages type="success" message={this.props.success}/>}
                <Toast ref={(el) => {this.growl = el}}></Toast>
               <div className="p-col-12">

                    <div className="card card-w-title">
                        <h1>Company Master</h1>
              
                        <Steps model={this.state.stepsItems} activeIndex={this.state.activeIndex} onSelect={(e) => this.setState({activeIndex: e.index})} readOnly={false} />

                        { grid }

                        <div className="mt3">
                            <div className="p-col-12 p-md-12" style={{textAlign:'right',paddingRight:'0px'}}>

                            { (this.state.activeIndex !== 0) && <Button icon=" pi pi-chevron-left" style={{marginBottom:'10px'}} className="p-button-primary p-button-rounded" label="Prev" onClick={this.prevMove}/> }
                            
                            { (this.state.activeIndex !== (this.state.stepsItems.length-1)) && <Button icon=" pi pi-chevron-right" style={{marginBottom:'10px'}} label="Next" className="p-button-primary p-button-rounded ml1" onClick={this.nextMove}/>}
                            </div>
                        </div>


                    </div>
                    { (this.state.activeIndex === 0) && 
                    <>
                    <FooterButton access={accessButton} disabled={!isEnabled} type={this.state.type.toLowerCase()} save={this.uploadData} reset={this.resetData}  to="" />
                    <br/><br/><br/><br/><br/>
                    </>   
                    }   
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return{
        loggedUserDetail : state.auth.userObject,
        userPref : state.auth.userPref,
        loading : state.master.loading,
        moduleLists : state.master.moduleLists,
        error : state.master.error,
        success : state.master.success,
        companyData : state.master.tableLists,
        leaveList : state.master.keywordValuesList,
        Employee : (state.keyword.Employee!==undefined) ? state.keyword.Employee : [],
        GetOrgUnit : (state.keyword.OrgUnit!==undefined) ? state.keyword.OrgUnit : [],
        ActionType : (state.keyword.ActionType!==undefined) ? state.keyword.ActionType : [],
        Cities : (state.keyword.City!==undefined) ? state.keyword.City : [],
    }
}
  
const mapDispatchToProps = dispatch => {
    return {
        getModuleLists : () => dispatch(actions.getModuleLists()),
        getMasterTableList: (table) => dispatch(actions.getMasterTableList(table)),
        getKeywordValues : () => dispatch(actions.getKeywordValues('TimeOffType')),
        processDynamicData: (model,type,data,func) => dispatch(actions.processDynamicData(model,type,data,func)),
        getMasterKeywordList : (value) => dispatch(actions.getMasterKeywordList(value)),
    }
}

  
export default connect(mapStateToProps,mapDispatchToProps)(CompanyMaster);